import { defineStore, acceptHMRUpdate } from 'pinia';
import WorkingView from '@/models/WorkingView';
import useSubprojectsStore from '@/stores/subprojects';
import usePlanningTimelineStore from '@/stores/planning/timeline';

const store = defineStore('ui-workingview', {
  state: () => ({
    currentPlanningId: null,
    currentPlanningWorkingViews: null,
    activeWorkingViewByPlanning: window.safeParseJSON(window.localStorageWrapper.getItem('activeWorkingViewByPlanning')) || {},
  }),

  getters: {
    getActiveWorkingView(state) {
      const viewId = state.activeWorkingViewByPlanning[state.currentPlanningId];
      return viewId && state.currentPlanningWorkingViews?.find(item => item.id == viewId) || null;
    },
    planningHasActiveWorkingView: () => (planning) => {
      return !! planning.workingView;
    },
  },

  actions: {
    reset() {
      this.currentPlanningId = null;
      this.currentPlanningWorkingViews = null;
    },
    sort() {
      this.currentPlanningWorkingViews.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    setActiveWorkingView(view) {
      if (view?.id) {
        this.activeWorkingViewByPlanning[view.planning_id] = view.id;
      } else {
        delete this.activeWorkingViewByPlanning[this.currentPlanningId];
      }
      window.localStorageWrapper.setItem('activeWorkingViewByPlanning', JSON.stringify(this.activeWorkingViewByPlanning));
    },
    loadPlanningViews(planningId) {
      return window.apiSrv.call(`plannings/${planningId}/views`, 'index').then((response) => {
        this.currentPlanningId = planningId;
        this.currentPlanningWorkingViews = (response?.data?.views || []).filter(a => a.config).sort((a, b) => (a.title < b.title ? -1 : 1)).map(viewData => new WorkingView(viewData));
      });
    },
    updatePlanning({ planning, view }) {
      if (view) { // if saved or new view
        view.applyWorkingView(planning);
        const subprojectsStore = useSubprojectsStore();
        if (subprojectsStore.promises.length) {
          Promise.all(subprojectsStore.promises).then(() => {
            if (planning.workingView != view) return;
            subprojectsStore.getAll.forEach((subproject) => {
              view.applyWorkingView(subproject, { isSubproject: true });
            });
            usePlanningTimelineStore().updateTimeline(planning.timeline);
          });
        }
      } else {
        WorkingView.applyLastSavedProjectVersion(planning);
        useSubprojectsStore().getAll.forEach((subproject) => {
          WorkingView.applyLastSavedProjectVersion(subproject);
        });
      }
      usePlanningTimelineStore().updateTimeline(planning.timeline);
      this.setActiveWorkingView(view);
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
